<div fxLayout="column" fxLayoutAlign="center" fxLayoutGap="40px">

    <div fxLayoutAlign="center">
        <h2>Escolha a unidade que deseja acessar: </h2>
    </div>

    <div fxLayout="row wrap" fxLayoutAlign="center center" fxLayoutGap="20px">
        <div *ngFor="let item of unidades">
            <div fxLayout="column">
                <button mat-fab [matTooltip]="item.nome" class="botao" [style.background-image]="getBackground(item)"
                    (click)="escolherUnidade(item.id)">
                    <mat-icon class="nao-foto"></mat-icon>
                </button>
            </div>
        </div>

    </div>
</div>